import React from 'react';
import { Image } from 'antd'
import Logo_ssc from '../../../../../assets/images/Logo_ssc.png';
import Logo_evision from '../../../../../assets/images/Logo_evision.png';
import Logo_song from '../../../../../assets/images/Logo_song.png';
import Logo_aha from '../../../../../assets/images/Logo_aha.png';
import Logo_quangtri from '../../../../../assets/images/Logo_quangtri.png';
import Logo_loc from '../../../../../assets/images/Logo_loc.png';
import Logo_aha_manual from '../../../../../assets/images/Logo_aha_manual.png';
import Logo_max_media from '../../../../../assets/images/Logo_max_media.png';
import Logo_hapu from '../../../../../assets/images/Logo_hapu.png';

const navLogo = (props) => {
  let toggleClass = ['mobile-menu']
  if (props.collapseMenu) {
    toggleClass = [...toggleClass, 'on']
  }

  let vendor = process.env.REACT_APP_VENDOR;

  return (
    <>
      <div className='navbar-brand header-logo'>
        <a href='#!' className='b-brand'>
          {
            vendor === 'ssc' ? (
              <Image src={Logo_ssc} preview='false' />
            ) : vendor === 'evision' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_evision}/>
            ) : vendor === 'aha' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '35px'}} src={Logo_aha}/>
            ) : vendor === 'hapu' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_hapu}/>
            ) : vendor === 'max_media' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_max_media}/>
            ) : vendor === 'loc' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '35px'}} src={Logo_loc}/>
            ) : vendor === 'aha_manual' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_aha_manual}/>
            ) : vendor === 'quangtri' ? (
              <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_quangtri}/>
            ) : (
              <Image preview='false' style={{ borderRadius: '5px' , width: '70px'}} src={Logo_song}/>
            )
          }
          <span className='b-title'>{process.env.REACT_APP_NAME}</span>
        </a>
        <a
          href='#!'
          className={toggleClass.join(' ')}
          id='mobile-collapse'
          onClick={props.onToggleNavigation}
        >
          <span />
        </a>
      </div>
    </>
  )
}

export default navLogo
